import * as ActionType from '../../constants/actionType';

// eslint-disable-next-line import/prefer-default-export
export function setConfig(config) {
  return {type: ActionType.SET_CONFIG, config};
}

// #endregion get connection url config (hubHost)
